import { defineComponent as _defineComponent } from 'vue'
import MessageList from '../MessageList';
import ChatEditor from '../ChatEditor';

export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  setup(__props) {


return { __sfc: true,MessageList, ChatEditor }
}

})